import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight, Zap } from 'lucide-react';
const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#0f0f0f] via-[#1a1a1a] to-[#0f0f0f] pt-20" data-id="element-122">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-123">
        <div className="absolute inset-0" style={{
        backgroundImage: `radial-gradient(circle at 2px 2px, rgba(255, 107, 53, 0.3) 1px, transparent 0)`,
        backgroundSize: '40px 40px'
      }} data-id="element-124"></div>
      </div>

      {/* Gradient Orbs */}
      <div className="absolute top-20 right-20 w-96 h-96 bg-[#FF6B35] rounded-full filter blur-3xl opacity-20 animate-pulse" data-id="element-125"></div>
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-[#FFA500] rounded-full filter blur-3xl opacity-20 animate-pulse" style={{
      animationDelay: '1s'
    }} data-id="element-126"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-127">
        <div className="max-w-5xl mx-auto text-center" data-id="element-128">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-129">
            <div className="inline-flex items-center gap-2 bg-[#FF6B35]/10 border border-[#FF6B35]/30 rounded-full px-4 py-2 mb-8" data-id="element-130">
              <Zap className="w-4 h-4 text-[#FF6B35]" data-id="element-131" />
              <span className="text-[#FF6B35] text-sm font-semibold" data-id="element-132">
                Professional Grade Equipment
              </span>
            </div>

            <h1 className="text-5xl md:text-7xl font-black text-white mb-6 leading-tight" data-id="element-133">
              Work Smarter,
              <br data-id="element-134" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF6B35] to-[#FFA500]" data-id="element-135">
                Not Harder
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-gray-400 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-136">
              Electric sprayers engineered for professionals. Cut your job time
              in half with consistent pressure and zero manual pumping.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-137">
              <Button size="lg" onClick={() => scrollToSection('products')} className="bg-gradient-to-r from-[#FF6B35] to-[#FFA500] hover:from-[#FFA500] hover:to-[#FF6B35] text-white border-0 shadow-lg shadow-[#FF6B35]/50 group" data-id="element-138">
                Shop Now
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-139" />
              </Button>
              <Button variant="outline" size="lg" onClick={() => scrollToSection('features')} className="border-2 border-gray-700 text-white hover:bg-gray-800 hover:border-gray-600" data-id="element-140">
                See Features
              </Button>
            </div>

            <div className="grid grid-cols-3 gap-8 mt-16 pt-16 border-t border-gray-800" data-id="element-141">
              <div data-id="element-142">
                <div className="text-3xl md:text-4xl font-black text-white mb-2" data-id="element-143">
                  60 PSI
                </div>
                <div className="text-sm text-gray-500 uppercase tracking-wider" data-id="element-144">
                  Consistent Pressure
                </div>
              </div>
              <div data-id="element-145">
                <div className="text-3xl md:text-4xl font-black text-white mb-2" data-id="element-146">
                  8 Hours
                </div>
                <div className="text-sm text-gray-500 uppercase tracking-wider" data-id="element-147">
                  Battery Life
                </div>
              </div>
              <div data-id="element-148">
                <div className="text-3xl md:text-4xl font-black text-white mb-2" data-id="element-149">
                  40 Feet
                </div>
                <div className="text-sm text-gray-500 uppercase tracking-wider" data-id="element-150">
                  Hose Reach
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}